export default __webpack_public_path__ + "static/outside-41464a5063e38b287e7113568ddd4cd8.webp";